<template>
  <div class="ac-page">
    <div class="ac-body">
      <!-- 分段控件：验证码登录 / 密码登录 -->
      <div class="tabs">
        <span
          class="tab"
          :class="{ active: mode === 'sms' }"
          @click="mode = 'sms'"
        >验证码登录</span>
        <span
          class="tab"
          :class="{ active: mode === 'password' }"
          @click="mode = 'password'"
        >密码登录</span>
      </div>

      <div class="form-stack">
        <!-- 短信验证码登录 -->
        <template v-if="mode === 'sms'">
          <!-- 手机号 -->
          <div class="ac-field with-prefix">
            <span class="prefix">+86</span>
            <span class="divider-v" />
            <input
              v-model.trim="telNum"
              type="tel"
              maxlength="11"
              class="ac-input"
              placeholder="请输入绑定手机号"
            />
          </div>

          <!-- 验证码 -->
          <div class="ac-field with-action">
            <input
              v-model.trim="code"
              type="tel"
              maxlength="6"
              class="ac-input"
              placeholder="请输入验证码"
            />
            <span
              class="field-action"
              :class="{ disabled: countdown > 0 }"
              @click="sendCode"
            >{{ countdown > 0 ? `${countdown}s后重发` : "获取验证码" }}</span>
          </div>
        </template>

        <!-- 账号密码登录 -->
        <template v-else>
          <!-- 账号名 -->
          <div class="ac-field">
            <input
              v-model.trim="userName"
              class="ac-input"
              placeholder="请输入账号名"
            />
          </div>

          <!-- 密码 -->
          <div class="ac-field">
            <input
              v-model.trim="password"
              type="password"
              class="ac-input"
              placeholder="请输入登录密码"
            />
          </div>
        </template>
      </div>

      <button class="ac-btn is-primary login-btn" :disabled="loading" @click="onLogin">
        {{ loading ? "登录中..." : "登录" }}
      </button>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import CryptoJS from "crypto-js";
import { reg, COOLING_DAYS, addDays } from "./config";
import {
  sendLoginSmsApi,
  loginBySmsApi,
  loginByPasswordApi,
} from "@/apis/accountCancel";

export default {
  name: "AccountCancelLogin",
  data() {
    return {
      mode: "sms", // sms | password
      telNum: "",
      code: "",
      userName: "",
      password: "",
      countdown: 0,
      timer: null,
      loading: false,
    };
  },
  created() {
    // 进入登录页即清空上一轮注销流程的用户信息，保证每次都是干净状态
    this.$store.commit("accountCancel/RESET");
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    checkPhone() {
      if (!reg.phone.test(this.telNum)) {
        Toast("请输入正确的手机号");
        return false;
      }
      return true;
    },
    async sendCode() {
      if (this.countdown > 0) return;
      if (!this.checkPhone()) return;
      try {
        await sendLoginSmsApi({ tel_num: this.telNum });
        Toast("验证码已发送");
        this.startCountdown();
      } catch (e) {
        // 错误提示已由响应拦截统一处理
      }
    },
    startCountdown() {
      this.clearTimer();
      this.countdown = 60;
      this.timer = setInterval(() => {
        if (this.countdown <= 1) {
          this.clearTimer();
          this.countdown = 0;
          return;
        }
        this.countdown -= 1;
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    async onLogin() {
      let request;
      let telNum = "";
      if (this.mode === "sms") {
        if (!this.checkPhone()) return;
        if (!reg.code.test(this.code)) {
          Toast("请输入 6 位验证码");
          return;
        }
        telNum = this.telNum;
        request = loginBySmsApi({
          tel_num: this.telNum,
          code: this.code,
        });
      } else {
        if (!this.userName) {
          Toast("请输入账号名");
          return;
        }
        if (!this.password) {
          Toast("请输入登录密码");
          return;
        }
        request = loginByPasswordApi({
          user_name: this.userName,
          // 密码加密：MD5(password + MD5(password))，与 h5sdk 账密登录一致
          password: CryptoJS.MD5(
            this.password + CryptoJS.MD5(this.password).toString()
          ).toString(),
        });
      }

      this.loading = true;
      try {
        const res = await request;
        const content = (res && res.content) || {};
        // 兼容后端「ret=1 但 content 为空」的登录失败场景：
        // 没有 close_token 即视为失败，提示并留在当前页（保留所选登录方式）
        if (!content.close_token) {
          Toast(this.mode === "password" ? "账号或密码错误，请重试" : "登录失败，请重试");
          return;
        }
        this.$store.commit("accountCancel/SET_SESSION", {
          closeToken: content.close_token,
          userId: content.user_id,
          telNum,
        });
        this.$store.commit("accountCancel/SET_ACCOUNT_INFO", content);

        // 已有审核中的注销申请：直接进入「注销审核中」状态页
        if (content.latest_close_apply_status === 0) {
          const applyTime = content.latest_close_apply_time || "";
          this.$store.commit("accountCancel/SET_RESULT", {
            applyTime,
            expireTime: addDays(applyTime, COOLING_DAYS),
            auditDays: COOLING_DAYS,
          });
          this.$router.push({
            name: "gameJump-accountCancelSuccess",
            query: { existing: 1 },
          });
          return;
        }

        this.$router.push({ name: "gameJump-accountCancelNotice" });
      } catch (e) {
        // 错误提示已由响应拦截统一处理
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.tabs {
  display: flex;
  gap: 0;
  margin-top: 28px;
  padding: 4px;
  background: #e0e3e9;
  border-radius: 12px;
}

.tab {
  flex: 1;
  padding: 9px 0;
  border-radius: 9px;
  color: #6b7280;
  font-size: 15px;
  text-align: center;

  &.active {
    background: #fff;
    color: #1b1f27;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(20, 25, 35, 0.12);
  }
}

.form-stack {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 40px;
}

.ac-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: $ac-text;
  font-size: 16px;

  &::placeholder {
    color: rgba(27, 31, 39, 0.42);
  }
}

.with-prefix {
  .prefix {
    font-weight: 600;
  }

  .divider-v {
    width: 1px;
    height: 20px;
    margin: 0 14px;
    background: currentColor;
    opacity: 0.18;
  }
}

.with-action {
  justify-content: space-between;
}

.field-action {
  flex-shrink: 0;
  margin-left: 12px;
  color: $ac-brand;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;

  &.disabled {
    color: $ac-sub;
  }
}

.login-btn {
  margin-top: 40px;
}
</style>
